import { BarcodeService } from './barcode.service';

export default angular
  .module('sfMobile.services.barcode', [])
  .service('barcodeService', BarcodeService).name;
